import i18n, { CN_LOCALE } from '@/i18n';

export type Region = 'cn' | 'global';

export function isGlobalLocale(): boolean {
  const locale = i18n.global.locale;
  const value = typeof locale === 'string' ? locale : locale.value;
  return value !== CN_LOCALE;
}

export function getRegion(): Region {
  return isGlobalLocale() ? 'global' : 'cn';
}
